import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";

import { getPosCheckoutSession } from "../../core/checkout.core";
import { useCookies } from "../useCookies.hook";

export function usePosCheckout() {
  const { isReady, locale } = useRouter();
  const sessionId = useCookies("sessionId");

  return useQuery({
    enabled: isReady && !!sessionId,
    queryFn: () => getPosCheckoutSession(),
    queryKey: ["posCheckout", locale, sessionId],
  });
}
